import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import gql from 'graphql-tag';
var CartQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query cartQuery($cartId: String = \"\") {\n    cart(cartRequest: { id: $cartId }) {\n      totals {\n        itemsQuantity\n      }\n    }\n  }\n"])));
export default CartQuery;